import React from "react"
import "./wallpaper.scss"

export default () => (
  <div className="wallpaper">
    <img src="images/wemade.gif" />
  </div>
)
